import { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { encodeWav24, encodeWav16, encodeMp3, resample } from "@/lib/mastering";

const btn = "inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-[background-color,transform] hover:-translate-y-0.5 disabled:opacity-50";

const save = (blob, filename) => {
  const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 60000);
};

export const MasteringExport = ({ buffer, name }) => {
  const [busy, setBusy] = useState("");
  const run = async (kind) => {
    setBusy(kind);
    try {
      const base = `${name || "master"} (TGA Master)`;
      if (kind === "wav24") save(encodeWav24(buffer), `${base} 24bit.wav`);
      if (kind === "wav16") save(encodeWav16(await resample(buffer, 44100)), `${base} 16bit-44k.wav`);
      if (kind === "mp3") save(await encodeMp3(await resample(buffer, 44100)), `${base} 320k.mp3`);
    } catch { toast.error("Esportazione non riuscita"); }
    finally { setBusy(""); }
  };
  const item = (kind, label, cls) => (
    <button key={kind} onClick={() => run(kind)} disabled={!!busy} className={`${btn} ${cls}`} data-testid={`mastering-download-${kind}`}>
      {busy === kind ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} {label}
    </button>
  );
  return (
    <div className="flex flex-wrap gap-3">
      {item("wav24", "WAV 24-bit (distributori)", "bg-emerald-500 text-[#151827] hover:bg-emerald-400")}
      {item("wav16", "WAV 16-bit 44,1 kHz + dither", "border border-white/20 hover:border-emerald-400")}
      {item("mp3", "MP3 320 kbps", "border border-white/20 hover:border-emerald-400")}
    </div>
  );
};
